export const PAGE_DATA = window.PAGE_DATA || null;
export const PAGE_DATA_URL_PREFIX = window.PAGE_DATA_URL_PREFIX || 'http://localhost:3000';
export const PAGE_DATA_JSON_URL = window.PAGE_DATA_JSON_URL || "/data/my.json"